import {
    Component,
    OnInit,
    EventEmitter,
    Output,
    ViewChild,
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DataService } from 'src/app/services/data.service';
import { Observable, of } from 'rxjs';
import { GridData } from '@tesla/angular2-tesla-common/grid/grid.models';
import { PartInfo } from 'src/app/models/partinfo';
import { Router } from '@angular/router';
import { ProposalService } from 'src/app/services/proposal.service';
import { PartMaster } from 'src/app/models/external/partMaster';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { FormService } from 'src/app/services/form';
import { PartBasicInfo } from 'src/app/models/partbasicinfo';
import { PendingProposalPartInfo } from 'src/app/models/internal/pendingproposalpartinfo';
import { CopyProposalDTO } from 'src/app/models/internal/copy-proposal-dto';
import { QueryPartNoProposalDTO } from 'src/app/models/internal/query-part-noproposal-dto';
import { PartInfoInProposal } from 'src/app/models/partinfoinproposal';
import { BaseGridPage } from 'src/app/core/basepages/allbasepages';
import { QueryPartMasterDTO } from 'src/app/models/internal/query-partmaster-dto';
import { SearchFilter } from 'src/app/models/internal/searchfilter';
import { MatRadioChange } from '@angular/material';
import { QueryApprovedPECreateDTO } from 'src/app/models/internal/query-approved-pe-create';
import { ValidateEffectivityFrom } from 'src/app/commonUI/customValidators/proposaliinfofields.valdiator';
import { CopyfromProposalListComponent } from '../../lists/copyfrom-proposal-list/copyfrom-proposal-list.component';
import { CopyFromProposalDTO } from 'src/app/models/internal/copyfrom-proposal-dto';
import { QueryExistingProposalForSupplierDTO } from 'src/app/models/internal/query-existingproposal-supplier-dto';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import UIHelper from 'src/app/core/utility/ui-helper';
import { AppSettings } from 'src/app/app.settings';
import { NGXLogger } from 'ngx-logger';
import { Console } from 'console';
import { QueryPartProposalsSearchDTO } from 'src/app/models/internal/query-partproposals-search-dto';
import { promise } from 'protractor';
import { rejects } from 'assert';
import { Constants } from 'src/app/core/constants';
import  Helper  from 'src/app/core/utility/helper';

export interface IBase7Proposals {
    ProposalId: number;
    PartNumber: string;
    SupplierCode: string;
    POUomCode: string;
}

@Component({
    selector: 'app-pe-createproposal',
    templateUrl: './pe-createproposal.component.html',
    styleUrls: ['./pe-createproposal.component.scss'],
})
export class PeCreateproposalComponent extends BaseGridPage implements OnInit {
    appSettings: AppSettings;
    autoCompleteUoMURL: string;
    @Output() formUpdated = new EventEmitter<number>();
    sourceProposalsToCopyFromList: any[];
    displayedColumns: string[] = [
        'Select',
        'PartNumber',
        'POUomCode',
        'SupplierCode',
        'ViewProposal',
    ];
    showProposalsToCopyFoundMessage = false;
    showProposalsToCopyNotFoundMessage = false;
    base7proposalsFoundMessage: string;
    base7proposalsNotFoundMessage: string;
    base7NumberToSearch: string;
    sourcePartInfoId: number;
    sourceProposalId: number;
    targetPartInfoIdList: PendingProposalPartInfo[] = [];
    dataSourceBase7Proposals: IBase7Proposals[];
    partInfoIdsCreated: number[] = [];
    partProposalInfoToBeCreatedList: PendingProposalPartInfo[];
    partProposalsForSameBase7List: PendingProposalPartInfo[];
    proposalFor: any;
    isPartFound = true;
    isPartProposalsForSameBase7Found = false;
    pe_createproposalForm: FormGroup;
    pe_searchPartForm: FormGroup;
    partMasterList: PartMaster[];
    existingForSupplierList: any[];
    partWithNoProposal: PartInfo;
    allItemsCheckBoxSelected: boolean = false;
    public formErrors = {
        partNumberToSearch: '',
        shipUoM: '',
        sourcePartNumbersSelected: '',
    };
    public formErrorsCopy = {
        itemsSelectedSource: '',
        EffectiveFrom: '',
    };
    autoCompletePartURL: string;
    searchClicked = false;
    showCopyFromComponent = false;
    copySourceUom: string;
    @ViewChild(CopyfromProposalListComponent)
    CopyFromProposalListComponent: CopyfromProposalListComponent;
    queryApprovedPECreateDTO: QueryApprovedPECreateDTO = new QueryApprovedPECreateDTO();
    alreadyExistsError =  'Proposal already exists for the given combination of Part Number, Supplier Code, UoM and SourceType';
    constructor(
        private dataService: DataService,
        private fb: FormBuilder,
        private proposalService: ProposalService,
        private toastService: ToastService,
        public formService: FormService,
        localstorageService: LocalstorageService,
        logger: NGXLogger,
        appSettings: AppSettings,
            private router: Router
    ) {
        super(localstorageService, logger, appSettings);
        this.pe_searchPartForm = this.fb.group({
            partNumberToSearch: [
                '',
                Validators.compose([
                    Validators.required,
                    Validators.maxLength(15),
                ]),
            ],
            proposalFor: ['1'],
        });
        this.pe_createproposalForm = this.fb.group({
            shipUoM: [
                '',
                Validators.compose([
                    Validators.required,
                    Validators.maxLength(15),
                ]),
            ],
            sourcePartNumbersSelected: [null],
        });
        this.appSettings = appSettings;
        this.autoCompletePartURL = this.appSettings.Packaging2APIUrl + '/externaldata/parts/search/supplier';
        this.autoCompleteUoMURL = this.appSettings.Packaging2APIUrl + '/externaldata/uom/all';

    }
    ngOnInit() {
        this.initFilterValues();
    }
    fillGrid(): void {
        this.sourceProposalsToCopyFromList = [];
        this.filter.Skip = this.skip;
        this.filter.Take = this.pageSize;
        this.allItemsCheckBoxSelected = false;
        this.getMasterParts();
    }
    resetFields() {
        this.partMasterList = [];
        this.partProposalsForSameBase7List = [];
        this.isPartFound = true;
        this.base7NumberToSearch = '';
        this.resetFormErrors();
    }

    resetFormErrors() {
        this.formErrors.partNumberToSearch = '';
        this.formErrors.sourcePartNumbersSelected = '';
        this.formErrors.shipUoM = '';
    }

    showCreateOptions() {
        return (
            (this.partMasterList && this.partMasterList.length > 0) ||
            this.partWithNoProposal
        );
    }

    showCreateOptionsForTesla() {
        return this.partMasterList && this.partMasterList.length > 0;
    }

    showCopyOptions() {
        return (
            this.sourceProposalsToCopyFromList &&
            this.sourceProposalsToCopyFromList.length > 0
        );
    }

    proposalForChanged() {
        this.searchClicked = false;
        this.showCopyFromComponent = false;
        if (this.proposalFor === 1) {
            this.autoCompletePartURL = this.appSettings.Packaging2APIUrl + '/externaldata/parts/search/supplier';
        } else {
            this.autoCompletePartURL = this.appSettings.Packaging2APIUrl + '/externaldata/parts/search/tesla';
        }
        this.pe_searchPartForm.controls['partNumberToSearch'].setValue('');
        this.resetFields();
    }

    searchMasterParts() {
        this.ValidateSearchForm();
        if (!this.pe_searchPartForm.valid) {
            return;
        }
        this.resetFields();
        this.searchClicked = true;
        const isForSupplier = this.IsProposalForSupplier();
        this.fillGrid();
    }
    getPartNumberToSearch() {
        let partNumber: string = this.pe_searchPartForm.controls[
            'partNumberToSearch'
        ].value;
        if (partNumber) {
            partNumber = partNumber.trim();
        }
        return partNumber;
    }

    getBase7ToSearch() {
        let partNumber = this.getPartNumberToSearch();
        if (partNumber) {
           partNumber = partNumber.substring(0, 7);
        }
        return partNumber;
    }

    getExistingProposalsToCopyFrom() {
        this.ValidateCreateForm();
        // TMS-4052
    //     if (this.pe_createproposalForm.valid) {
    //         this.checkExistingProposals().subscribe((response: any) => {
    //         if (response && response.Data != null && response.Data.length > 0) {
    //             this.existingForSupplierList = response.Data;
    //             this.toastService.error(this.alreadyExistsError);
    //         } else {
    //             this.logDebug('no existing ok to proceed');
    //             if (this.pe_createproposalForm.valid) {
    //                 let selectedParts = this.getSelectedTargetParts();
    //                 this.queryApprovedPECreateDTO.SupplierCodes = selectedParts.map(
    //                     a => a.SupplierCode
    //                 );
    //                 this.queryApprovedPECreateDTO.ShipUoM = this.getShipUom();
    //                 this.showCopyFromComponent = true;
    //                 // this.CopyFromProposalListComponent.getProposalsForPE(
    //                 //     this.queryApprovedPECreateDTO
    //                 // );
    //                 this.CopyFromProposalListComponent.setDefaultPartNumber(this.getBase7ToSearch());
    //                 this.CopyFromProposalListComponent.fillGrid();
    //             }
    //         }
    //     });
    // }

        if (this.pe_createproposalForm.valid) {
            const selectedParts = this.getSelectedTargetParts();
            // this.queryApprovedPECreateDTO.SupplierCodes = selectedParts.map(
            //     a => a.SupplierCode
            // );
            this.queryApprovedPECreateDTO.ShipUoM = this.getShipUom();
            this.showCopyFromComponent = true;
            // this.CopyFromProposalListComponent.getProposalsForPE(
            //     this.queryApprovedPECreateDTO
            // );
            this.CopyFromProposalListComponent.setDefaultPartNumber(this.getBase7ToSearch());
            this.CopyFromProposalListComponent.fillGrid();
        }
    }

    getSelectedTargetParts() {
        return this.partMasterList.filter(a => a.IsSelected === true);
    }
    checkExistingProposals() {
        this.ValidateCreateForm();

        const queryDTOs: QueryExistingProposalForSupplierDTO[] = [];
        const selectedParts = this.getSelectedTargetParts();
        if (selectedParts) {
            selectedParts.forEach(e => {
                const dto: QueryExistingProposalForSupplierDTO = new QueryExistingProposalForSupplierDTO();
                dto.PartNumber = e.PartNumber;
                dto.SupplierCode = e.SupplierCode;
                dto.SourceTypeId = e.SourceTypeId;
                dto.POUoMCode = this.getShipUom();
                this.logDebug('adding in to be checked for existing', dto);
                queryDTOs.push(dto);
            });
        } else {
            return null;
        }
        return this.dataService.getExistingAllProposals_Supplier(queryDTOs);
    }

    getMasterParts() {
        const queryPartMasterDTO: QueryPartMasterDTO = new QueryPartMasterDTO();
        const searchFilter: SearchFilter = new SearchFilter();
        searchFilter.Take = this.filter.Take;
        searchFilter.Skip = this.filter.Skip;
        queryPartMasterDTO.SearchFilter = searchFilter;
        queryPartMasterDTO.PartNumber = this.getPartNumberToSearch();
        queryPartMasterDTO.IsForSupplier = this.IsProposalForSupplier();

        // get master part records (multiple possible for diff supplier / warehouse) based on part number provided
        this.dataService
            .getMasterParts(queryPartMasterDTO)
            .subscribe((response: any) => {
                // this.partInfo = data
                if (response && response.Data != null && response.Data.length > 0) {
                    this.partMasterList = response.Data;
                    // filter parts for warehouses
                    // this.partMasterList = this.partMasterList.filter(
                    //     a =>
                    //         a.WarehouseID === 56 ||
                    //         a.WarehouseID === 58 ||
                    //         a.WarehouseID === 64
                    // );
                    this.gridView = of({
                        data: this.partMasterList,
                        // total: this.partMasterList ? this.partMasterList.length : 0, // for external take the total
                        total: response ? response.Total : 0,
                    });
                } else {
                    this.toastService.error('Part not found', true);
                }
                this.isPartFound =
                    this.partMasterList && this.partMasterList.length > 0;
            });
        // get master part records (multiple possible for diff supplier / warehouse) based on part number provided
        if (!this.isPartFound) {
            this.showCopyFromComponent = false;
            this.toastService.error('Part not found...');
        }
    }

    copyProposal(copyFromProposalDTO: CopyFromProposalDTO, parts: PendingProposalPartInfo[]) {
        // partProposalInfoToBeCreatedList won't be empty if parts were created
        this.targetPartInfoIdList = parts;
        const copyProposalDTO: CopyProposalDTO = {
            Id: 0,
            Enabled: true,
            IsSelected: true,
            SourcePartInfoId: copyFromProposalDTO.SourcePartInfoId,
            SourceProposalId: copyFromProposalDTO.SourceProposalId,
            TargetPartInfoIdList: this.targetPartInfoIdList,
            isForSupplier: this.IsProposalForSupplier(),
            isTeslaCreated: true,
            EffectiveFrom: copyFromProposalDTO.EffectiveFrom,
        };
        this.logDebug('copying prop with dto', copyProposalDTO);
        this.dataService
            .copyProposal(copyProposalDTO)
            .subscribe((response: any) => {
                if (response != null) {
                    // this.toastService.success('Proposal copied successfully');
                    this.proposalService.RefreshsavedproposalIds(response.Data);
                    this.toastService.success('Proposal(s) copied to create the following records', true);
                    this.navigateToSavedProposals();
                } else {
                    this.toastService.error('Could not copy the proposal');
                }
            });
    }

    /*
    TMS-12409 add function which checks if a proposal exists for any selected
    parts. it handles single and multiple select of parts. The function returns
    error message if any proposals exist for any searched part.
    
    Update:
    TMS-14551 Criteria for determining existing proposal
    Remove exising proposal check
    */ 
    createProposal(parts: any) {
        // TMS-4052
        // this.checkExistingProposals().subscribe((response: any) => {
        //     if (response && response.Data != null && response.Data.length > 0) {
        //         this.existingForSupplierList = response.Data;
        //         this.toastService.error(this.alreadyExistsError);
        //     } else {
        //         this.logDebug('no existing ok to proceed');
        //         let isForSupplier = this.IsProposalForSupplier();
        //         if (this.pe_createproposalForm.valid) {
        //             // first create PartInfo records and then redirect to create proposal page
        //             this.partProposalInfoToBeCreatedList = parts;
        //             this.proposalService.RefreshpartInfoToBeCreatedList(
        //                 this.partProposalInfoToBeCreatedList
        //             );
        //             this.router.navigate(['../', 'proposal']);
        //         }
        //     }
        // });
        
        // check if it is created for Tesla and set querystring accordingly
        /*  if (!this.IsProposalForSupplier()) {
            this.router.navigate(['../', 'proposal'], { queryParams: { ForTesla: '1' } });
        } else {
            // for supplier
            this.router.navigate(['../', 'proposal']);
        } */ 

        if (this.pe_createproposalForm.valid) {
            // first create PartInfo records and then redirect to create proposal page
            this.partProposalInfoToBeCreatedList = parts;
            this.proposalService.RefreshpartInfoToBeCreatedList(
                this.partProposalInfoToBeCreatedList
            );
            // this.logDebug('this.proposalFor=' + this.proposalFor);
            // check if it is created for Tesla and set querystring accordingly
            if (!this.IsProposalForSupplier()) {
                this.router.navigate(['../', 'proposal'], { queryParams: { ForTesla: '1' } });
            } else {
                // for supplier
                this.router.navigate(['../', 'proposal']);
            }
        }
    }

    createOrCopyProposal(copyFromProposalDTO: CopyFromProposalDTO) {
        this.ValidateCreateForm();
        if (this.pe_createproposalForm.valid) {
            // first create PartInfo records and then redirect to create proposal page
            const selectedTargetParts = this.partMasterList.filter(
                a => a.IsSelected === true
            );
            const partInfoList: PendingProposalPartInfo[] = this.createPendingProposalPartInfo(selectedTargetParts);
            this.logDebug(
                'Syncing Part Info before copying proposal',
                partInfoList
            );
            // Go to CreateProposal
            if (copyFromProposalDTO) {// in case of copy it won't null
                this.copyProposal(copyFromProposalDTO, partInfoList);
            } else {
                this.createProposal(partInfoList);
            }
        }
    }

    createPendingProposalPartInfo(selectedTargetParts: PartMaster[]) {
        const partInfoList: PendingProposalPartInfo[] = [];
        selectedTargetParts.forEach(masterPart => {
            const partToAdd = new PendingProposalPartInfo();
            // Object.assign(partToAdd, masterPart);
            partToAdd.PartId = masterPart.PartId;
            partToAdd.PartNumber = masterPart.PartNumber;
            partToAdd.SupplierId = masterPart.PreferredSupplierId;
            partToAdd.SupplierCode = masterPart.SupplierCode;
            partToAdd.SourceTypeId = masterPart.SourceTypeId;
            partToAdd.StockUomCode = masterPart.UnitOfMeasure;
            partToAdd.ParentSourceTypeId = masterPart.SourceTypeId;
            partToAdd.ParentSourceTypeDescription = masterPart.WarehouseDescription;
            partToAdd.SourceTypeDescription = masterPart.WarehouseDescription;
            partToAdd.POUomCode = this.getShipUom();
            partInfoList.push(partToAdd);
        });
        return partInfoList;
    }

    getShipUom() {
        return this.pe_createproposalForm.controls['shipUoM'].value;
    }

    onRowSelectedChange(event: any, partMaster: PartMaster) {
        const isSelected: boolean = event.checked;
        if (isSelected) {
            // Implementation for multiple select
            if (this.checkIfOtherPartsWithDifferentUOMSelected(partMaster)) {
                partMaster.IsSelected = false;
                event.source.checked = false;
                this.toastService.error('All selected Parts must have the same UOM');
            } else {
                this.partMasterList.find(
                    a => (a.SourceTypeId === partMaster.SourceTypeId &&
                        a.SupplierCode === partMaster.SupplierCode &&
                        a.UnitOfMeasure === partMaster.UnitOfMeasure)
                ).IsSelected = true;
            }
            if (
                this.partMasterList.filter(a => a.IsSelected === true).length === this.partMasterList.length
            ) {
                this.allItemsCheckBoxSelected = true;
            }
            this.pe_createproposalForm.controls[
                'sourcePartNumbersSelected'
            ].setErrors(null);
        } else {
            this.partMasterList.find(
                a => a.SourceTypeId === partMaster.SourceTypeId
            ).IsSelected = false;
            this.allItemsCheckBoxSelected = false;
        }
    }

    checkIfOtherPartsWithDifferentUOMSelected(partInfo: PartMaster) {
        const selectedParts = this.partMasterList.filter(
            a => (a.IsSelected === true )
        );
        // first time a part is selected
        if (!selectedParts || selectedParts.length === 0) {
            return false;
        }
        let foundItem = null;
        foundItem = selectedParts.find(x => x.UnitOfMeasure != partInfo.UnitOfMeasure );
        return foundItem;
    }

    setAllSelected(isSelected: boolean) {
        if (isSelected) {
            this.pe_createproposalForm.controls[
                'sourcePartNumbersSelected'
            ].setErrors(null);
        }
        this.partMasterList.forEach(part => {
            part.IsSelected = isSelected;
        });
    }
    ValidateSearchForm() {
        this.formErrors = this.formService.validateForm(
            <FormGroup>this.pe_searchPartForm,
            this.formErrors
        );
    }

    ValidateCreateForm() {
        const selectedParts = this.partMasterList.filter(
            a => a.IsSelected === true
        );
        if (!selectedParts || selectedParts.length === 0) {
            this.pe_createproposalForm.controls[
                'sourcePartNumbersSelected'
            ].setErrors({ selectAtLeastOneGridRow: true });
            // this.formErrors.partNumberSelection = "Please select at least one part number";
        }
        this.formErrors = this.formService.validateForm(
            <FormGroup>this.pe_createproposalForm,
            this.formErrors
        );
    }
    viewProposal(id: number) {
        this.proposalService.RefreshproposalToViewId(id);
        window.open('pe-proposalsnapshot?id=' + id, '_blank');
    }

    IsProposalForSupplier() {
        return this.pe_searchPartForm.controls['proposalFor'].value == 1;
    }
    navigateToSavedProposals() {
        this.router.navigate(['/saved-proposals'] );
        // window.location.href = '/saved-proposals/';

    }
}
